import { FormControl, FormGroup, Validators } from "@angular/forms"
import { CustomValidatorsService } from "../../services/custom.validators.service";

export function buildForm() {
    return new FormGroup({
        fullCode:new FormControl(undefined as any,[Validators.required,CustomValidatorsService.number,Validators.minLength(4),Validators.maxLength(4)]),
        c1: new FormControl(undefined as any, [Validators.required, CustomValidatorsService.number,Validators.minLength(1),Validators.maxLength(1)]),
        c2: new FormControl(undefined as any, [Validators.required, CustomValidatorsService.number,Validators.minLength(1),Validators.maxLength(1)]),
        c3: new FormControl(undefined as any, [Validators.required, CustomValidatorsService.number,Validators.minLength(1),Validators.maxLength(1)]),
        c4: new FormControl(undefined as any, [Validators.required, CustomValidatorsService.number,Validators.minLength(1),Validators.maxLength(1)]),
    });
}